import React from "react";
import utils from "../../modules/utils";
import moment from "moment";
import "moment/locale/it";
import history from "../../modules/history";
import Stepper from "../shared/stepper.js";
import PortaDocumentiFAUP from "../shared/porta_documenti_faup.js";
import { trackPageView } from "../../modules/datalayer.js";
import "../riepilogo/riepilogo.css";

class ThankYouPageCq extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      nome: "",
      email: "",
      codice_fiscale: "",
      telefono: "",
      data_appuntamento: "",
      filiale: "",
      indirizzo_filiale: "",
      prodotto: 3
    };
    this.goModifica = this.goModifica.bind(this);
  }
  componentWillMount() {
    const global_state = utils.getState();
    const data_appuntamento =
      moment(
        global_state.data_appuntamento + " " + global_state.orario_appuntamento
      ).format("dddd DD MMMM") +
      " ore " +
      moment(
        global_state.data_appuntamento + " " + global_state.orario_appuntamento
      ).format("HH:mm");
    this.setState({
      nome: global_state.utente.nome + " " + global_state.utente.cognome,
      email: global_state.utente.email,
      codice_fiscale: global_state.utente.codice_fiscale,
      telefono: global_state.utente.telefono,
      data_appuntamento: data_appuntamento,
      filiale: global_state.filiale,
      indirizzo_filiale: "",
      prodotto: global_state.prodotto
    });
  }
  componentDidMount() {
    trackPageView("thank-you-page-FAUP");
  }
  goModifica() {
    history.goBack();
  }
  render() {
    return (
      <div id="riepilogo">
        <Stepper percentage="100" />
        <div className="grid-container">
          <div className="grid-x grid-padding-x">
            <div className="cell">
              <div>
                <h2>La tua richiesta &egrave; stata presa in carico.</h2>
                <h3>Ti contatteremo al più presto.</h3>
              </div>
              <div className="panel container-recap">
                <div className="grid-container">
                  <div className="grid-x grid-padding-x">
                    <div className="cell medium-4 medium-offset-4 ">
                      <div className="cell medium-4">
                        <div className="grid-x grid-padding-x">
                          <div className="cell small-2 medium-12">
                            <svg
                              width="30"
                              height="30"
                              viewBox="0 0 30 30"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M15.0896 0.674805C19.64 0.674805 23.2592 4.96033 23.2592 10.1757C23.2592 15.391 19.64 19.6765 15.0896 19.6765C10.5392 19.6765 6.91992 15.391 6.91992 10.1757C6.91992 4.96033 10.5392 0.674805 15.0896 0.674805ZM15.0896 17.8015C18.5276 17.8015 21.3842 14.419 21.3842 10.1757C21.3842 5.93228 18.5276 2.5498 15.0896 2.5498C11.6515 2.5498 8.79492 5.93228 8.79492 10.1757C8.79492 14.419 11.6515 17.8015 15.0896 17.8015Z"
                                fill="#000000"
                              />
                              <mask
                                id="mask0"
                                mask-type="alpha"
                                maskUnits="userSpaceOnUse"
                                x="6"
                                y="0"
                                width="18"
                                height="20"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M15.0896 0.674805C19.64 0.674805 23.2592 4.96033 23.2592 10.1757C23.2592 15.391 19.64 19.6765 15.0896 19.6765C10.5392 19.6765 6.91992 15.391 6.91992 10.1757C6.91992 4.96033 10.5392 0.674805 15.0896 0.674805ZM15.0896 17.8015C18.5276 17.8015 21.3842 14.419 21.3842 10.1757C21.3842 5.93228 18.5276 2.5498 15.0896 2.5498C11.6515 2.5498 8.79492 5.93228 8.79492 10.1757C8.79492 14.419 11.6515 17.8015 15.0896 17.8015Z"
                                  fill="white"
                                />
                              </mask>
                              <path
                                d="M17.4128 9.05935C18.9378 10.4225 20.6333 11.1734 22.4503 10.9221L22.1934 9.06476C21.0213 9.22689 19.8169 8.69348 18.6624 7.66145C18.2922 7.33046 17.9568 6.97354 17.6645 6.61726C17.4919 6.40687 17.3751 6.24803 17.321 6.16733L16.485 4.92188L15.7318 6.21904C14.9968 7.48484 13.8288 8.31101 12.3131 8.77355C10.9416 9.19206 9.46199 9.27031 8.14663 9.14961C7.95528 9.13205 7.82352 9.11516 7.76211 9.10533L7.46582 10.9568C7.56731 10.973 7.74051 10.9952 7.9753 11.0168C9.51189 11.1578 11.2201 11.0674 12.8603 10.5669C14.3557 10.1106 15.6259 9.34973 16.5845 8.24078C16.8253 8.50424 17.1021 8.78162 17.4128 9.05935Z"
                                fill="#000000"
                              />
                              <mask
                                id="mask1"
                                mask-type="alpha"
                                maskUnits="userSpaceOnUse"
                                x="7"
                                y="4"
                                width="16"
                                height="8"
                              >
                                <path
                                  d="M17.4128 9.05935C18.9378 10.4225 20.6333 11.1734 22.4503 10.9221L22.1934 9.06476C21.0213 9.22689 19.8169 8.69348 18.6624 7.66145C18.2922 7.33046 17.9568 6.97354 17.6645 6.61726C17.4919 6.40687 17.3751 6.24803 17.321 6.16733L16.485 4.92188L15.7318 6.21904C14.9968 7.48484 13.8288 8.31101 12.3131 8.77355C10.9416 9.19206 9.46199 9.27031 8.14663 9.14961C7.95528 9.13205 7.82352 9.11516 7.76211 9.10533L7.46582 10.9568C7.56731 10.973 7.74051 10.9952 7.9753 11.0168C9.51189 11.1578 11.2201 11.0674 12.8603 10.5669C14.3557 10.1106 15.6259 9.34973 16.5845 8.24078C16.8253 8.50424 17.1021 8.78162 17.4128 9.05935Z"
                                  fill="white"
                                />
                              </mask>
                              <path
                                d="M3.82793 27.4175C4.03202 24.6975 5.20697 23.222 8.03097 22.0775C10.3372 21.1429 11.6779 19.6842 12.272 18.0845L10.5143 17.4318C10.0974 18.5542 9.12679 19.6103 7.32673 20.3398C3.47882 21.8992 1.91992 24.2683 1.91992 28.355V29.2925H28.2592V28.355C28.2592 24.2683 26.7003 21.8992 22.8524 20.3398C20.9544 19.5708 19.9868 18.4498 19.6173 17.2969L17.8318 17.8691C18.3641 19.5302 19.7102 21.0898 22.1482 22.0776C24.9722 23.222 26.1471 24.6975 26.3512 27.4175H3.82793Z"
                                fill="#000000"
                              />
                              <mask
                                id="mask2"
                                mask-type="alpha"
                                maskUnits="userSpaceOnUse"
                                x="1"
                                y="17"
                                width="28"
                                height="13"
                              >
                                <path
                                  d="M3.82793 27.4175C4.03202 24.6975 5.20697 23.222 8.03097 22.0775C10.3372 21.1429 11.6779 19.6842 12.272 18.0845L10.5143 17.4318C10.0974 18.5542 9.12679 19.6103 7.32673 20.3398C3.47882 21.8992 1.91992 24.2683 1.91992 28.355V29.2925H28.2592V28.355C28.2592 24.2683 26.7003 21.8992 22.8524 20.3398C20.9544 19.5708 19.9868 18.4498 19.6173 17.2969L17.8318 17.8691C18.3641 19.5302 19.7102 21.0898 22.1482 22.0776C24.9722 23.222 26.1471 24.6975 26.3512 27.4175H3.82793Z"
                                  fill="white"
                                />
                              </mask>
                            </svg>
                          </div>
                          <div className="cell small-10 medium-12">
                            <p className="appDetails">
                              <span className="uppercase">
                                {this.state.nome}
                              </span>
                              <br />
                              <span>{this.state.codice_fiscale}</span>
                              <br />
                              <span>{this.state.email}</span>
                              <br />
                              <span>{this.state.telefono}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <PortaDocumentiFAUP />
      </div>
    );
  }
}

export default ThankYouPageCq;



// WEBPACK FOOTER //
// ./src/components/thank_you_page_AUP/index.js